import { render, staticRenderFns } from "./AutomationEmailEditorPage.vue?vue&type=template&id=a8bb3520&scoped=true"
import script from "./AutomationEmailEditorPage.vue?vue&type=script&lang=js"
export * from "./AutomationEmailEditorPage.vue?vue&type=script&lang=js"
import style0 from "./AutomationEmailEditorPage.vue?vue&type=style&index=0&id=a8bb3520&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bb3520",
  null
  
)

export default component.exports